import React, { useEffect, useState, useRef, useContext } from "react";
import { baseUrl } from '../../config.js'
import { BuscadorContext } from "../Buscador/BuscadorContext.js";
import { Imagenes, nombres, idsRC, idServiciosRC, iconoServicio } from '../../almacen.js';

import flecha from '../../img/Flecha.png';

import Favoritos from '../../img/Favoritos.png';
import Popular from '../../img/temp/Popular.png';
import Congelador from '../../img/temp/Congelador.png';
import Puertos from '../../img/temp/Puertos.png';
import Filtros from '../../img/Filtros.png';
import RangoPrecios from '../../img/Precio.png';
import Cerrar from '../../img/Cerrar.png';
import Inmediata from '../../img/Inmediata.png';

import PriceUp from '../../img/PriceUp.png';
import PriceDown from '../../img/PriceDown.png';
import EspacioUp from '../../img/EspacioUp.png';
import EspacioDown from '../../img/EspacioDown.png';
import TimeUp from '../../img/TimeUp.png';
import TimeDown from '../../img/TimeDown.png';

import './Etiquetas.css';

const Etiquetas = ({ setModalFiltro, impuestos, setImpuestos })=>{

    const {filtros, totalFavs, setTotalFavs, tiposDisponibles} = useContext(BuscadorContext);
    const [totalFiltros, setTotalFiltros] = useState(0);
    const [busquedasGuardadas, setBusquedasGuardadas] = useState([]);
    const [scroll, setScroll] = useState({x1:0, x2:0});
    const [selected, setSelected] = useState(0);
    const order = {
        "Best" : {
            "nombre" : "Mejores",
            "imagen" : Popular
        },
        "Recent" : {
            "nombre" : "Más Recientes",
            "imagen" : TimeDown,
        },
        "Oldest" : {
            "nombre" : "Más Antiguos",
            "imagen" : TimeUp,
        },
        "MoreAvailability" : {
            "nombre" : "Más Espacios",
            "imagen" : EspacioDown,
        },
        "LessAvailability" : {
            "nombre" : "Menos Espacios",
            "imagen" : EspacioUp,
        },
        "PriceDown" : {
            "nombre" : "Mayor Costo",
            "imagen" : PriceDown,
        },
        "PriceUp" : {
            "nombre" : "Menor Costo",
            "imagen" : PriceUp,
        },
    };

    const divEtiquetas = useRef();
    const wrapperEtiquetas = useRef();
    
    useEffect(()=>{
        const stored = localStorage.getItem('busquedasGuardadas');
        if(stored) {
            setBusquedasGuardadas(JSON.parse(stored));
        }
    }, [])
    useEffect(()=>{
        const total = (filtros?.services?.length + filtros?.types?.length) || 0;
        setTotalFiltros(total);
    },[filtros])
    
    useEffect(()=>{
        const x2 = divEtiquetas.current.scrollWidth - (divEtiquetas.current.offsetWidth + divEtiquetas.current.scrollLeft);
        setScroll({...scroll, x2: x2});
    },[busquedasGuardadas])

    useEffect(()=>{
        const handleScroll = event => {
            const x1 = divEtiquetas.current.scrollLeft;
            const x2 = divEtiquetas.current.scrollWidth - (divEtiquetas.current.offsetWidth + divEtiquetas.current.scrollLeft);
            setScroll({x1, x2});
        };
    
        divEtiquetas.current.addEventListener('scroll', handleScroll);
    
        return () => {
            if(divEtiquetas.current)
                divEtiquetas.current.removeEventListener('scroll', handleScroll);
        };
    }, [])

    useEffect(()=>{
        if(scroll.x1 > 0)
            wrapperEtiquetas.current.classList.add('izq')
        else
            wrapperEtiquetas.current.classList.remove('izq')
            if(scroll.x2 > 0)
                wrapperEtiquetas.current.classList.add('der')
            else
                wrapperEtiquetas.current.classList.remove('der')
    }, [scroll])

    const mover = (dir)=>{
        const pixeles = Math.ceil(divEtiquetas.current.scrollLeft+(dir*divEtiquetas.current.offsetWidth*.7));
        divEtiquetas.current.scroll(pixeles,0);
    }

    return(
        <div className="filtrar">
            <div className="wrapperEtiquetas" ref={wrapperEtiquetas}>
                <div className="mover left" onClick={()=>{
                        mover(-1)
                    }}>
                    <span>
                        <img src={flecha} alt="Deslizar Izquierda"/>
                    </span>
                </div>
                <div className="mover right" onClick={()=>{
                    mover(1)
                }}>
                    <span>
                        <img src={flecha} alt="Deslizar Derecha"/>
                    </span>
                </div>
                <div className="etiquetas" ref={divEtiquetas}>
                    {filtros["order"] &&
                        <Etiqueta datos={order[filtros["order"]]} selected={true} type={"order"}/>
                    }
                    {filtros["min"] !== undefined &&
                        <Etiqueta datos={{nombre: "$"+filtros["min"]+" - $"+filtros["max"], imagen: RangoPrecios}} selected={true} type={"price"}/>
                    }
                    {filtros["types"] &&
                        filtros.types.map(x=>{
                            return(
                                <Etiqueta datos={{id: x, nombre: nombres[x], imagen: Imagenes[idsRC[x]]}} selected={true} type={"types"}/>
                            )
                        })
                    }
                    {filtros["services"] &&
                        filtros.services.map(x=>{
                            return(
                                <Etiqueta datos={{id: x, nombre: idServiciosRC[x], imagen: iconoServicio(x)}} selected={true} type={"services"}/>
                            )
                        })
                    }
                    <Etiqueta datos={{nombre:"Favoritos"+(totalFavs != 0 ? " ("+totalFavs+")" : ""),imagen: Favoritos,type: "fav",}} selected={filtros?.fav} type={"fav"}/>
                    <Etiqueta datos={{nombre:"Vistos Recientemente",imagen: TimeDown,type: "vistos"}} selected={filtros?.vistosIds !== undefined} type={"vistos"}/>
                    {busquedasGuardadas.length === 0 ? (
                        <>
                            <Etiqueta datos={{nombre:"Reserva Inmediata",imagen: Inmediata, type: "inmediata"}} selected={filtros?.reserve === 'Immediate'} type={"inmediata"}/>
                            {tiposDisponibles?.map(tipo => {
                                const idNum = Number(tipo);
                                if(filtros?.types?.includes(idNum) || filtros?.types?.includes(tipo)) return null;
                                return (
                                    <Etiqueta key={`dyn-${tipo}`} datos={{id: idNum, nombre: nombres[tipo], imagen: Imagenes[idsRC[tipo]], type: "dynamic_type"}} selected={false} type={"dynamic_type"}/>
                                );
                            })}
                        </>
                    ) : (
                        busquedasGuardadas.map((busqueda, i) => (
                            <Etiqueta key={i} datos={{nombre: busqueda.nombre, imagen: Filtros, type: "saved_search", filtrosGuardados: busqueda.filtros}} selected={false} type={"saved_search"}/>
                        ))
                    )}
                </div>
            </div>
            <div className="filtros">
                <button 
                    className={totalFiltros ? "conFiltros" : ""}
                    onClick={()=>{
                        setModalFiltro(true);
                    }}>
                    {totalFiltros!==0 &&
                        <div className="totalFiltros">{totalFiltros}</div>
                    }
                    <img src={Filtros}/>
                    <span>Filtros</span>
                </button>
                <label className="switchImpuestos">
                    <span className="switchImpuestos__label">Mostrar total sin impuestos</span>
                    <input type="checkbox" checked={impuestos} onChange={(e)=>{
                        setImpuestos(e.target.checked)
                    }}/>
                    <span className="switchImpuestos__track">
                        <span className="switchImpuestos__thumb"></span>
                    </span>
                </label>
            </div>
        </div>
    )
}

const Etiqueta = ({datos, selected, setSelected, i, type})=>{
    const {filtros, setFiltros} = useContext(BuscadorContext);
    return (
        <div className={(!datos?.nombre ? 'placeholder ' : '')+(selected ? "sel" : "")}
            onClick={()=>{
                if(type == "fav"){
                    setFiltros({...filtros, fav:true})
                }
                if(type == "vistos"){
                    const vistos = JSON.parse(localStorage.getItem('vistos') || '[]');
                    setFiltros({...filtros, vistosIds: vistos})
                }
                if(type == "inmediata"){
                    setFiltros({...filtros, reserve: 'Immediate'})
                }
                if(type == "dynamic_type"){
                    const types = filtros.types || [];
                    if(!types.includes(datos.id) && !types.includes(Number(datos.id))) setFiltros({...filtros, types: [...types, Number(datos.id)]})
                }
                if(type == "saved_search"){
                    setFiltros({...filtros, ...datos.filtrosGuardados})
                }
            }}>
            {selected && 
                <button className="cerrar" onClick={(e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    if(type == "order"){
                        setFiltros({...filtros, order : undefined})
                    }
                    else if(type == "price"){
                        setFiltros({...filtros, min: undefined, max: undefined, time: undefined})
                    }
                    else if(type == "services"){
                        const services = filtros.services.filter(x=>{
                            console.log(x, datos.id)
                            return x !== datos.id;
                        })
                        setFiltros({...filtros, services})
                    }
                    else if(type == "types"){
                        const types = filtros.types.filter(x=>{
                            console.log(x, datos.id)
                            return x !== datos.id;
                        })
                        setFiltros({...filtros, types})
                    }
                    else if(type == "fav"){
                        setFiltros({...filtros, fav:undefined})
                    }
                    else if(type == "vistos"){
                        setFiltros({...filtros, vistosIds: undefined})
                    }
                    else if(type == "inmediata"){
                        setFiltros({...filtros, reserve: 'All'})
                    }
                    else if(type == "dynamic_type"){
                        const types = filtros.types?.filter(x => x !== datos.id && x !== Number(datos.id));
                        setFiltros({...filtros, types})
                    }
                }}>
                    <img src={Cerrar}/>
                </button>
            }
            <div className="imgEtiqueta">
                <img src={datos?.imagen}/>
            </div>
            <div className="nombreEtiqueta">{datos?.nombre}</div>
        </div>
    )
}

export default Etiquetas;